import { config } from "core/config/app";
import LoginPage from "./pages/LoginPage";
import SignUpPolicy from "./pages/SignUpPolicy";
import ContentPolicyUsedApp from "./pages/ContentPolicyUseApp";
import ContentPolicyAgreeInfo from "./pages/ContentPolicyAgreeInfo";
import SignUpForm from "./pages/SignUpForm";
import SignUpSuccess from "./pages/SignUpSuccess";
import ForgotPwCheckMail from "./pages/ForgotPwCheckMail";
import ForgotPwRequestOtp from "./pages/ForgotPwRequestOtp";
import ForgotPwForm from "./pages/ForgotPwForm";

const router = [
  {
    name: "LOGIN",
    auth: false,
    path: `${config?.basename}/login`,
    element: <LoginPage />,
    title: "Login ",
  },
  {
    name: "SIGNUP_POLICY",
    auth: false,
    path: `${config?.basename}/policy-signup`,
    element: <SignUpPolicy />,
    title: "Signup policy",
  },
  {
    name: "TERM_OF_USE",
    auth: false,
    path: `${config?.basename}/term-of-use`,
    element: <ContentPolicyUsedApp />,
    title: "Term of use ",
  },
  {
    name: "PRIVACY_POLICY",
    auth: false,
    path: `${config?.basename}/privacy-policy`,
    element: <ContentPolicyAgreeInfo />,
    title: "Term of use",
  },
  {
    name: "SIGNUP_FORM",
    auth: false,
    path: `${config?.basename}/signup-form`,
    element: <SignUpForm />,
    title: "Signup user",
  },
  {
    name: "SIGNUP_SUCCESS",
    auth: false,
    path: `${config?.basename}/signup-success`,
    element: <SignUpSuccess />,
    title: "Signup suceess",
  },
  {
    name: "FORGOT_PW_CHECK_MAIL",
    auth: false,
    path: `${config?.basename}/forgot-pw-check-mail`,
    element: <ForgotPwCheckMail />,
    title: "Check mail ",
  },
  {
    name: "FORGOT_PW_REQUEST_OTP",
    auth: false,
    path: `${config?.basename}/forgot-pw-request-otp`,
    element: <ForgotPwRequestOtp />,
    title: "Verfiy OTP ",
  },
  {
    name: "FORGOT_PW_FORM",
    auth: false,
    path: `${config?.basename}/forgot-pw-form`,
    element: <ForgotPwForm />,
    title: "Forgot password",
  },
];
export default router;
